/**
 * 降级黄条轮询
 *
 * 技术方案：https://km.sankuai.com/collabpage/1529640773
 */

import { Subject, BehaviorSubject, interval } from 'rxjs';
import { switchMap, combineLatest, map, merge, distinctUntilChanged } from 'rxjs/operators';

import store from '../../../store';
import request from '../../../../../utils/axiosWrapper';

const defaultLoopInterval = 120; // 默认轮询间隔 120 秒

const demotionKeySubject = new Subject<string | null>();
const pollingIntervalInSeconds$ = new BehaviorSubject(defaultLoopInterval);

const distinctPollingIntervalInSeconds$ = pollingIntervalInSeconds$.pipe(distinctUntilChanged());

const init = () => {
    /**
     * 1. 从 store 中取出 demotion 配置 + 当前 hash
     * 2. 取出匹配的 demotionKey
     * 3. RxJS 监听 demotionKey 变化，启动轮询
     */

    store.subscribe(() => {
        const storeData = store.getState();
        const demotionConfig = storeData.shellCommon.demotionConfig;
        const currentPageHash = storeData.mainContent.pageHash || '';

        const matchedConfig = demotionConfig.filter(entry =>
            currentPageHash.startsWith(entry.page),
        );

        if (matchedConfig.length >= 1) {
            demotionKeySubject.next(matchedConfig[0].key);
        } else {
            demotionKeySubject.next(null);
            if (storeData.shellCommon.activeDemotionContext !== '') {
                store.dispatch({
                    type: 'shellCommon/setData',
                    payload: {
                        activeDemotionContext: '',
                    },
                });
            }
        }
    });
};

let preDemotionKey: string | null = null;

demotionKeySubject
    .pipe(
        distinctUntilChanged(), // 连续值去重
        combineLatest(distinctPollingIntervalInSeconds$),
        switchMap(([demotionKey, latestInterval]) => {
            return interval(latestInterval * 1000).pipe(map(() => demotionKey));
        }),
        merge(demotionKeySubject.pipe(distinctUntilChanged())), // eslint-disable-line
    )
    .subscribe(demotionKey => {
        if (demotionKey !== null) {
            request
                .rawGet<{
                    code: number;
                    data: {
                        demotionInfo: {
                            [index: string]: {
                                /** true为命中降级 */
                                hitStrategy: boolean;
                                /** 降级展示文案 */
                                context: string;
                                /** 服务端下发的轮询间隔 */
                                intervalSecond: number;
                            };
                        };
                    };
                }>('/gw/api/config/demotion/interval/info', {
                    params: {
                        demotionKey,
                        demotionType: demotionKey === preDemotionKey ? 2 : 1,
                    },
                })
                .then(
                    response => {
                        if (response.code === 0 && response.data && response.data.demotionInfo) {
                            if (response.data.demotionInfo[demotionKey]) {
                                const demotionInfo = response.data.demotionInfo[demotionKey];
                                store.dispatch({
                                    type: 'shellCommon/setData',
                                    payload: {
                                        activeDemotionContext: demotionInfo.hitStrategy
                                            ? demotionInfo.context
                                            : '',
                                    },
                                });

                                // 更新轮询间隔
                                pollingIntervalInSeconds$.next(demotionInfo.intervalSecond);
                            }
                        }
                    },
                    () => {},
                );
        }

        preDemotionKey = demotionKey;
    });

export default {
    init,
};
